let currentCategory = null;

const CATEGORY_TEXT = {
    'shipping': "Shipping & taxes calculated at checkout.\nInternational orders pay duties & taxes separately."
};

function showInfo(category, bubbleId) {
    const textElem = document.getElementById(bubbleId);

    if (currentCategory === category) {
        textElem.textContent = '';
        currentCategory = null;
    } else {
        textElem.textContent = CATEGORY_TEXT[category];
        currentCategory = category;
    }
}